import { render, staticRenderFns } from "./createModel.vue?vue&type=template&id=38336635"
import script from "./createModel.vue?vue&type=script&lang=js"
export * from "./createModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports